import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type State = {
  isLoading: boolean;
  autocompleteList: string[];
  autocompleteListLoaded: boolean;
};
const initialState: State = {
  isLoading: false,
  autocompleteList: [],
  autocompleteListLoaded: false,
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'autocompleteSearch',
  initialState,
  reducers: {
    clearAutocompleteAction: (state) => {
      state.autocompleteList = [];
    },
    setAutocompleteAction: (state, action) => {
      state.autocompleteList = action.payload;
      state.autocompleteListLoaded = false;
    },
    errorAutocompleteAction: (state) => {
      state.autocompleteListLoaded = false;
    },
    setAutocompletePreloaderAction: (state, action) => {
      state.autocompleteListLoaded = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    autocompleteRequestAction: (state, action: PayloadAction<string>) => state,
  },
});

export const {
  clearAutocompleteAction,
  errorAutocompleteAction,
  autocompleteRequestAction,
  setAutocompleteAction,
  setAutocompletePreloaderAction,
} = slice.actions;
